<template>
  <div
      class="item-detail"
      v-if="valueList.length"
  >
    <div class="nano">
      <ul
          id="article_consulList"
          class="consulList nano-content"
          v-infinite-scroll="load"
          :infinite-scroll-disabled="loadLock"
          :infinite-scroll-distance="20"
      >
        <li class="border-bottom" v-for="(item, index) in valueList" :key="index" v-bind:class="{'active': activeIndex === index}">
          <div class="media-body-wrap">
            <div class="title-wrap" @click="gotoDetail(item, index)">
              <span class="title-text overflow-hidden-1">
                {{item.sourceAsMap.title}}
              </span>
            </div>
            <div class="foot-message">
              <span
                  class="border border-primary text-primary f12 p-11"
                  v-if="item.sourceAsMap.catName"
              >{{item.sourceAsMap.catName}}</span>
              <span class="line" v-if="item.sourceAsMap.catName"></span>
              <span class="f12 text-muted">{{timeTampToTime(item.sourceAsMap.published)}}</span>
              <span
                  class="line"
                  v-if="item.sourceAsMap.published && (item.highlightFields && item.highlightFields.one_level_state ||
                    (item.sourceAsMap.one_level_state && item.sourceAsMap.one_level_state.length))"
              ></span>
              <div
                  v-if="item.sourceAsMap && (item.sourceAsMap.tags||item.sourceAsMap.one_level_state)"
                  class="p-ss-none key-words-list"
              >
                <span
                    v-for="(ite, inde) in
                                mergeMoreWords(item.sourceAsMap.one_level_state,item.sourceAsMap.tags)"
                    :key="inde"
                    class="float-left f12 text-key border"
                    @click="searchItem(ite)"
                    v-html="ite"
                    v-if="inde < 8"
                >
                </span>
              </div>
              <div class="p-ss-none" v-else>
                <span
                    v-for="(ite, inde) in item.sourceAsMap.tags"
                    :key="inde"
                    class="float-left f12 text-key border"
                    @click="searchItem(ite)"
                    v-html="ite"
                    v-if="inde < 8"
                >
                </span>
              </div>
            </div>
            <div class="item-text">
              {{item.sourceAsMap.abs|| item.sourceAsMap.description}}
            </div>

          </div>
          <span class="video-times">{{item.sourceAsMap.videoTimes}}</span>
        </li>
        <p
            class="text-center p-2 w-100"
            v-if="value.spaceLoadShow"
        >
          <i class="fa fa-spinner fa-pulse fa-2x mt-3"></i>
        </p>
        <p
            class="text-center p-2 w-100"
            v-if="value.spaceEndShow"
        >No more data...</p>
      </ul>
    </div>
  </div>
  <div
      v-else
      class="nodata text-center"
  >
    <img
        style="padding-top: 20%"
        src="/db/static/images/no_data.png"
        alt
    />
    <p style="color: #999999; padding-top: 20px">Sorry no data</p>
  </div>
</template>

<script>
import mergeMoreWords from '@/views/search/mixin/mergeMoreWords'
import MixinTime from '@/views/TheHome/mixins/dateTime'
import * as _ from 'lodash'
import stubFalse from 'lodash/stubFalse'

export default {
  name: 'itemList',
  components: {},
  mixins: [ mergeMoreWords, MixinTime],
  props: {
    value: {
      type: Object,
      default() {
        return {
          isDetail: true
        }
      }
    },
    resultValue: {
      type: Object
    }
  },
  data() {
    return {
      isFoot: false,
      advanceQuery: [],
      text: [] || '',
      loadLock: false,
      activeIndex: -1,
    }
  },
  created() {
    this.$eventBus.$on('isAdvanced', (value) => {
      this.advanceQuery = JSON.parse(localStorage.getItem('advanceQuery'))
      // let text = this.resultValue.result ? this.resultValue.result : this.resultValue.keyWord
      if (this.$route.query.advanced === 'true') {
        const textArr = []
        _.forEach(this.advanceQuery, (item) => {
          if (item.midd !== 2) {
            textArr.push(item.value)
          }
        })
        this.text = textArr
      }
    })
  },
  computed: {
    valueList() {
      this.value.content.forEach((i) => {
        if (i.sourceAsMap.modelType === 'video') {
          const arr = i.sourceAsMap.description.split('|')
          if (arr.length === 2) {
            let times = arr[1]
            i.sourceAsMap.description = arr[0]
            if (times <= 0) {
              i.sourceAsMap.videoTimes = '00:00:00'
            } else {
              const hh = parseInt(times / 3600)
              const shh = times - hh * 3600
              let ii = parseInt(shh / 60)
              let ss = shh - ii * 60
              i.sourceAsMap.videoTimes = (hh < 10 ? '0' + hh : hh) + ':' + (ii < 10 ? '0' + ii : ii) + ':' + (ss < 10 ? '0' + ss : ss)
            }
          }
        }
      })
      return this.value.content || []
    },
    filtertText() {
      let text = this.resultValue.result ? this.resultValue.result : this.resultValue.keyWord
      if (this.text && this.$route.query.advanced === 'true') {
        text = this.text
      }
      return text || ''
    }
  },
  methods: {
    gotoDetail(val, index) {
      this.activeIndex = index;
      this.$emit('gotoDetail', val)
    },
    searchItem(val) {
      val = val.replace(/<.*?>/ig, '')
      this.$emit('searchItem', { name: val })
    },
    searchSub(val) { // 副标题
      this.$eventBus.$emit('searchSub', val)
    },
    load() {
      const divHeight = document.getElementById('article_consulList').clientHeight
      const nScrollHeight = document.getElementById('article_consulList').scrollHeight
      const nScrollTop = document.getElementById('article_consulList').scrollTop
     
      if (divHeight+nScrollTop+1>nScrollHeight) {
        if (this.value.page == this.value.pageCount) {
          this.loadLock = true
        } else {
          this.loadLock = false
        }
        if (!this.loadLock) {
          this.value.page++
          this.$emit('jumpList', true, this.value.page)
        }
        // console.log(divHeight,nScrollHeight,nScrollTop)
        return
      }
      // if (this.value.page == this.value.pageCount) {
      //   this.value.page = this.value.pageCount
      //   this.value.spaceEndShow = true
      //   this.loadLock = true
      // } else {
      //   if (this.value.page == this.value.pageCount) {
      //     this.loadLock = true
      //     return
      //   } else {
      //     this.loadLock = false
      //   }
      //   if (!this.loadLock) {
      //     this.value.page += 1
      //     this.$emit('jumpList', true, this.value.page)
      //   }
      // }
    }
  }
}
</script>

<style scoped lang="scss">
.title-text{
  position: relative;
  // &:after {
  //   content: '';
  //   display: block;
  //   width: 20px;
  //   height: 20px;
  //   border-radius: 10px;
  //   background: url("../images/news-icon.png") center center no-repeat;
  //   background-size:  50% 50%;
  //   background-color: rgb(248, 142, 82);
  //   position: absolute;
  //   left: -35px;
  //   top: 5px;
  // }
}
@media screen and (max-width: 555px) {
  .p-ss-none {
    display: none !important;
  }
}

.item-detail {
  width: 100%;
  height: 100%;

  /deep/ em {
    color: #f56c6c !important;
  }

  /*.nano {*/
  /*  height: calc(100% - 50px);*/
  /*}*/

  .item-img {
    flex: none;
    width: 140px;
    /*margin-right: 18px;*/
    height: 112px;
    object-fit: scale-down;
  }

  .text-key {
    padding: 0 2px;
    margin-left: 3px;
    color: #6c757d;
    /*letter-spacing: 1px;*/
    cursor: pointer;

    &:hover {
      color: #0056b3;
    }
  }

  .title-wrap {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .border-bottom:hover, .border-bottom.active {
    background-color: rgb(235, 245, 255);
  }

  .media-body-wrap {
    width: 100%;
    padding: 0 10px 0 20px;
    margin: auto;
  }

  .title-text {
    font-weight: bolder;
    font-size: 16px;
    cursor: pointer;
    color: #343a40;
    /deep/ em {
      font-weight: bolder;
      font-size: 18px;
    }
  }

  .consulList {
    padding: 0;

    li {
      display: flex;
      padding: 2% 0 2.5% 0;
      box-sizing: border-box;
      /*height: 20%;*/

      .tag-status {
        margin-left: 18px;
        padding: 0 12px;
      }

      .item-text {
        margin: 10px 0;
        color: #8590a6;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .foot-message {
        display: flex;
        width: 100%;
        margin-top: 10px;
        align-items: center;

        > span {
          flex-shrink: 0;
        }

        .line {
          width: 1px;
          height: 15px;
          background: #d9d9d9;
          margin: 0 10px;
        }

        .key-words-list {
          height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .list-pagination {
    text-align: right;
  }
}

.video-times {
  position: absolute;
  color: white;
  font-weight: bold;
  text-shadow: 5px 5px 10px gray;
  right: 8px;
  z-index: 999;
  margin-top: 85px;
}
</style>
